import { render, staticRenderFns } from "./RestrictedModal.vue?vue&type=template&id=7bbb7eca&"
import script from "./RestrictedModal.vue?vue&type=script&lang=ts&"
export * from "./RestrictedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports